import styled from 'styled-components';
import { Stack } from '@optimus-web/core';

export const StackCleared = styled(Stack)`
    clear: both;
`;
